import React, {useEffect, useState} from "react"

import DatePicker from "react-datepicker";



const DateInput = (props) => {
    const [focused, setFocused] = useState(false);


  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };


    return(
        <div
            className={`input-block mb-3 form-focus ${
              focused || props.selected ? "focused" : ""
            }`}
          >
            <div className="cal-icon focused ">
              <DatePicker
                // dateFormat="yyyy-MM-dd"
                className="form-control floating datetimepicker"
                {...props}
                // selected={selectedDate}
                // onChange={handleDateChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                dateFormat="MM/dd/yyyy"
                autoComplete="off"
              />
            </div>
            <label className="focus-label">{props.label}</label>
          </div>
    )
}

export default DateInput